import {MultiCurrencyPriceFragment} from '../../../gql/graphql';
import {ModelContext} from '../../../types/checkoutApp.types';
import {SPECS} from '../../../common/constants';
import {MultiCurrencyPrice} from '@wix/auto_sdk_ecom_cart-v-2';

export class PriceModel {
  public amount: number;
  public formattedAmount: string;

  constructor(params: PriceModel) {
    this.amount = params.amount;
    this.formattedAmount = params.formattedAmount;
  }

  public static fromCheckoutV1(price: MultiCurrencyPriceFragment | undefined | null, modelContext: ModelContext) {
    return new PriceModel({
      amount: Number(modelContext.useConvertedPrice ? price?.convertedAmount : price?.amount) || 0,
      formattedAmount: modelContext.flowAPI.experiments.enabled(SPECS.ClientFormattingForPrices)
        ? modelContext.formatAmount(modelContext.useConvertedPrice ? price?.convertedAmount ?? '' : price?.amount ?? '')
        : (modelContext.useConvertedPrice ? price?.formattedConvertedAmount : price?.formattedAmount) ??
          /* istanbul ignore next */ '',
    });
  }

  /* istanbul ignore next */
  // eslint-disable-next-line sonarjs/no-identical-functions
  public static fromCartV2(price: MultiCurrencyPrice | undefined | null, modelContext: ModelContext): PriceModel {
    return new PriceModel({
      amount: Number(modelContext.useConvertedPrice ? price?.convertedAmount : price?.amount) || 0,
      formattedAmount: modelContext.flowAPI.experiments.enabled(SPECS.ClientFormattingForPrices)
        ? modelContext.formatAmount(modelContext.useConvertedPrice ? price?.convertedAmount ?? '' : price?.amount ?? '')
        : (modelContext.useConvertedPrice ? price?.formattedConvertedAmount : price?.formattedAmount) ??
          /* istanbul ignore next */ '',
    });
  }
}
